import { css } from 'styled-components';
import { BREAKPOINTS } from './constants';

export const MEDIA_QUERIES_MOBILE_FIRST = {
  SMALL: `screen and (min-width: ${BREAKPOINTS.XSMALL}px)`,
  MEDIUM: `screen and (min-width: ${BREAKPOINTS.SMALL}px)`,
  LARGE: `screen and (min-width: ${BREAKPOINTS.MEDIUM}px)`,
};

type CSSStyles = ReturnType<typeof css> | false;

type MediaQueries = {
  [Breakpoint in keyof typeof MEDIA_QUERIES_MOBILE_FIRST as Lowercase<Breakpoint>]?: CSSStyles;
};

export const mediaQueries = ({ small, medium, large }: MediaQueries) => css`
  ${small
    ? css`
        @media ${MEDIA_QUERIES_MOBILE_FIRST.SMALL} {
          ${small}
        }
      `
    : ''}
  ${medium
    ? css`
        @media ${MEDIA_QUERIES_MOBILE_FIRST.MEDIUM} {
          ${medium}
        }
      `
    : ''}
  ${large
    ? css`
        @media ${MEDIA_QUERIES_MOBILE_FIRST.LARGE} {
          ${large}
        }
      `
    : ''}
`;
